

define(['squid/index', './directive', 'components/xo-address-components/src/address-normalization/route', 'components/xo-address-components/src/add-address/directive', '../shipping-address/directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-add-shipping.route', ['squid', 'xo-shipping-address.directive', 'xo-add-address.directive', 'xo-address-normalization.route']).factory('$AddShippingRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('AddShippingRoute', {
            name: 'addShipping',
            directive: 'xo-add-shipping',
            titleContent: 'addShipping.addAddress',
            trackingData: {
                fptiState: 'add_shipping'
            },
            loginRequired: true,
            children: [{
                name: '$AddressNormalizationRoute',
                attributes: {
                    id: 'token',
                    sidebar: 'sidebar',
                    address: 'address',
                    'done-fn': 'uponNormalization'
                }
            }]
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/select-shipping/add-shipping/route.js
// module id = ./components/xo-member-components/src/select-shipping/add-shipping/route.js
// module chunks = 1